export enum PaymentErrorCode {
  AuthenticationFailed = 'authentication_failed',
  AuthenticationNotHandled = 'authentication_not_handled',
  Blocked = 'blocked',
  CallIssuer = 'call_issuer',
  CardVelocityExceeded = 'card_velocity_exceeded',
  DoNotHonor = 'do_not_honor',
  ExpiredCard = 'expired_card',
  GenericDecline = 'generic_decline',
  IncorrectCvc = 'incorrect_cvc',
  IncorrectNumber = 'incorrect_number',
  InsufficientFunds = 'insufficient_funds',
  InvalidAccount = 'invalid_account',
  InvalidAmount = 'invalid_amount',
  InvalidCvc = 'invalid_cvc',
  InvalidPin = 'invalid_pin',
  LostCard = 'lost_card',
  PickupCard = 'pickup_card',
  RestrictedCard = 'restricted_card',
  RevocationOfAllAuthorizations = 'revocation_of_all_authorizations',
  RevocationOfAuthorization = 'revocation_of_authorization',
  StolenCard = 'stolen_card',
  TransactionNotAllowed = 'transaction_not_allowed',
  TryAgainLater = 'try_again_later',
}

type PaymentErrorContent = {
  buttonText: string;
  message: string;
};

const INSUFFICIENT_FUNDS_ERROR: PaymentErrorContent = {
  buttonText: 'Try again or change payment method',
  message:
    'Payment failed — insufficient funds or limit reached. Your bank declined the payment due to low balance or spending limit.',
};

const BANK_DECLINED_ERROR: PaymentErrorContent = {
  buttonText: 'Try again or change payment method',
  message: 'Payment was declined by your bank. The bank did not approve this transaction.',
};

const AUTHENTICATION_FAILED_ERROR: PaymentErrorContent = {
  buttonText: 'Try again or change payment method',
  message: "Payment authentication failed We couldn't confirm the payment with your bank.",
};

const CARD_DETAILS_INCORRECT_ERROR: PaymentErrorContent = {
  buttonText: 'Edit payment method',
  message: 'Card details are incorrect. Please check your card number, expiration date, and security code.',
};

const CARD_CANNOT_BE_USED_ERROR: PaymentErrorContent = {
  buttonText: 'Change your payment method',
  message: "This card can't be used",
};

export const PAYMENT_ERROR_CONTENT: Record<PaymentErrorCode, PaymentErrorContent> = {
  [PaymentErrorCode.AuthenticationFailed]: AUTHENTICATION_FAILED_ERROR,
  [PaymentErrorCode.AuthenticationNotHandled]: AUTHENTICATION_FAILED_ERROR,
  [PaymentErrorCode.Blocked]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.CallIssuer]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.CardVelocityExceeded]: INSUFFICIENT_FUNDS_ERROR,
  [PaymentErrorCode.DoNotHonor]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.ExpiredCard]: CARD_DETAILS_INCORRECT_ERROR,
  [PaymentErrorCode.GenericDecline]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.IncorrectCvc]: CARD_DETAILS_INCORRECT_ERROR,
  [PaymentErrorCode.IncorrectNumber]: CARD_DETAILS_INCORRECT_ERROR,
  [PaymentErrorCode.InsufficientFunds]: INSUFFICIENT_FUNDS_ERROR,
  [PaymentErrorCode.InvalidAccount]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.InvalidAmount]: INSUFFICIENT_FUNDS_ERROR,
  [PaymentErrorCode.InvalidCvc]: CARD_DETAILS_INCORRECT_ERROR,
  [PaymentErrorCode.InvalidPin]: CARD_DETAILS_INCORRECT_ERROR,
  [PaymentErrorCode.LostCard]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.PickupCard]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.RestrictedCard]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.RevocationOfAllAuthorizations]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.RevocationOfAuthorization]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.StolenCard]: CARD_CANNOT_BE_USED_ERROR,
  [PaymentErrorCode.TransactionNotAllowed]: BANK_DECLINED_ERROR,
  [PaymentErrorCode.TryAgainLater]: AUTHENTICATION_FAILED_ERROR,
};

const DEFAULT_ERROR_CONTENT: PaymentErrorContent = {
  buttonText: 'Try again or change payment method',
  message: 'Payment failed',
};

export const getPaymentErrorContent = (code?: null | string): PaymentErrorContent => {
  if (!code) {
    return DEFAULT_ERROR_CONTENT;
  }

  const errorCode = code as PaymentErrorCode;
  return PAYMENT_ERROR_CONTENT[errorCode] || DEFAULT_ERROR_CONTENT;
};
